import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const details = [{
  label: "Dublin 4 Local Areas",
  value: "Ringsend, Sandymount, Ballsbridge, Donnybrook, Irishtown",
  link: "/PlumberDublin4Page"
}, {
  label: "Dublin South",
  value: "D2, D4, D6, D6W, D8, D10, D12, D14, D16, D18, D20, D22, D24"
}, {
  label: "Dublin North",
  value: "D1, D3, D5, D7, D9, D11, D13, D15, D17"
}, {
  label: "South County",
  value: "Blackrock, Booterstown, Dún Laoghaire, Stillorgan and surrounding areas within County Dublin."
}, {
  label: "North County",
  value: "Swords, Malahide, Portmarnock, Skerries, Balbriggan"
}, {
  label: "Response Time",
  value: "Urgent emergency call-outs are prioritised. Call to confirm our soonest available attendance time."
}, {
  label: "Availability",
  value: "Emergency call-outs — call to confirm the soonest we can attend"
}];
export default function AreasCoveredAcrossDublin() {
  return <section data-section-id="236055" id="areas-covered-across-dublin" className="bg-background text-foreground py-24 md:py-32">
      <div className="container mx-auto px-6 max-w-4xl">
        <div className="mb-16 text-center">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-primary tracking-tight">
            Areas Covered Across Dublin
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-8 mb-24">
          {details.map((item, i) => <div key={i} data-index={i} className="flex flex-col border-b border-border pb-4 transition-all duration-300 hover:border-primary">
              <span className="text-xs font-mono text-muted-foreground uppercase tracking-widest mb-2">
                {item.label}
              </span>
              <span className="text-xl font-default font-medium text-foreground">
                {item.link ? <Link to={item.link} className="hover:text-primary underline decoration-primary/50 underline-offset-4 transition-colors">
                    {item.value}
                  </Link> : item.value}
              </span>
            </div>)}
        </div>

        <p className="text-center text-sm text-muted-foreground mb-12">
          This list is not exhaustive. Contact us with your Eircode to check current service availability.
        </p>

        <div className="flex flex-col items-center justify-center gap-6">
          <p className="text-muted-foreground font-default text-center max-w-md">
            Don't see your specific area listed? We cover all of Dublin and surrounding regions.
          </p>
          <Button asChild variant="outline" size="lg" className="rounded-md border-primary text-primary bg-transparent hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-md h-auto py-4 px-10 text-base font-default font-bold tracking-wide">
            <Link to="/ContactPage">Check Availability</Link>
          </Button>
        </div>
      </div>
    </section>;
}